module.exports = __webpack_public_path__ + "static/media/passat-saloon.0f10b194.png";